export default class CurrencyService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('currencies', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('currencies/' + id, params)
	}

	getEntitiesForSelectBox(params) {
		return this.apiService.callGet('currencies/simple', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/CurrencyService.js